import classNames from 'classnames'

import { getUniqueGroups } from './utils'

import styles from './Filters.module.scss'

export const GroupFilter = ({ products, onClick, selectedGroup }) => (
    <div className={styles.filters}>
        <div className={styles.filterBox}>
            <p className={styles.title}>Group:</p>
            <ul className={styles.list}>
                {getUniqueGroups(products).map(group => (
                    <li
                        key={group}
                        className={classNames(styles.item, { [styles.isActiveItem]: selectedGroup === group })}
                        onClick={() => onClick(group)}
                    >
                        {group}
                    </li>
                ))}
            </ul>
        </div>
    </div>
)

export const CurrencyFilter = ({ currencies, onClick, selectedCurrency }) => (
    <div className={styles.filters}>
        <div className={styles.filterBox}>
            <p className={styles.title}>Currency:</p>
            <ul className={styles.list}>
                {currencies.map(({ id, currency }) => (
                    <li
                        key={id}
                        className={classNames(styles.item, {
                            [styles.isActiveItem]: selectedCurrency === currency,
                            [styles.isDisabledItem]: selectedCurrency === currency,
                        })}
                        onClick={() => onClick(currency)}
                    >
                        {currency}
                    </li>
                ))}
            </ul>
        </div>
    </div>
)
